import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix leaflet default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

export default function SPPDMap({ items = [], height = 380 }) {
  const points = items.filter((i) => i.lat != null && i.lng != null);
  const center = points.length > 0 ? [points[0].lat, points[0].lng] : [-2.5, 118.0]; // Indonesia center
  const zoom = points.length > 0 ? 5 : 4;

  return (
    <div className="rounded-xl overflow-hidden border border-slate-200" style={{ height }} data-testid="sppd-map">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* Makassar HQ marker */}
        <CircleMarker center={[-5.1477, 119.4327]} pathOptions={{ color: '#FBBF24', fillColor: '#FBBF24', fillOpacity: 0.9 }} radius={8}>
          <Popup><strong>Pemerintah Kota Makassar</strong><br />Bagian Prokopim - Setda</Popup>
        </CircleMarker>
        {points.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]}>
            <Popup>
              <div className="text-xs">
                <div className="font-semibold text-sm text-red-700">
                  {p.jenis_perjalanan === 'Luar Negeri' ? `${p.kota_luar_negeri}, ${p.negara_tujuan}` : `${p.tujuan_kota}, ${p.tujuan_provinsi}`}
                </div>
                {p.jenis_perjalanan === 'Luar Negeri' && <div className="text-[10px] uppercase font-bold text-red-600">🌐 Luar Negeri</div>}
                <div className="mt-1"><strong>{p.pejabat_nama}</strong></div>
                <div className="text-slate-600">{p.jabatan}</div>
                <div className="mt-1 text-slate-700">{p.keperluan}</div>
                <div className="mt-1"><span className="font-mono">{p.nomor_sppd}</span></div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
